import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { getType } from 'typesafe-actions';
import { CardList, CardListAction } from '../../../../common/components/cards';
import { Checkbox, SearchField } from '../../../../common/components/fields';
import { rootSelector } from '../../../../common/selectors/selectors';
import { useQuery } from '../../../../common/utils/useQuery';
import { exhibitsActions } from '../../exhibits.actions';
import { ExhibitDto } from '../../exhibits.dtos';
import ExhibitListItem from './exhibitListItem';

const ExhibitList = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const query = useQuery();

  const systemExhibits = rootSelector((state) => state.exhibits.list);

  const [showInactive, setShowInactive] = useState<boolean>(false);
  const [exhibits, setExhibits] = useState<ExhibitDto[]>([]);

  const searchQuery = query.get('search');

  useEffect(() => {
    dispatch({ type: getType(exhibitsActions.request) });
  }, [dispatch]);

  useEffect(() => {
    setExhibits(systemExhibits);
  }, [systemExhibits]);

  const onAdd = () => {
    history.push('/exhibits/create');
  };

  const onSearch = (searchQuery: string) => {
    const query = searchQuery.toLowerCase();
    const filteredExhibits = systemExhibits.filter((s) => {
      return (
        s.name.toLowerCase().includes(query) ||
        (!isNaN(new Date(s.startDate!).getFullYear()) &&
          moment(s.startDate).format('MM/DD/YYYY').includes(query)) ||
        moment(s.startDate).format('M/D/YYYY').includes(query) ||
        (!isNaN(new Date(s.endDate!).getFullYear()) &&
          moment(s.endDate).format('MM/DD/YYYY').includes(query)) ||
        (!isNaN(new Date(s.endDate!).getFullYear()) &&
          moment(s.endDate).format('M/D/YYYY').includes(query))
      );
    });
    setExhibits(filteredExhibits);
  };

  return (
    <CardList
      actions={[
        <CardListAction
          key='Add new exhibit'
          onClick={onAdd}
          tooltip='Add new exhibit'
        />,
      ]}
      cards={exhibits
        .filter((u) => showInactive || u.isActive === true)
        .map((u, index) => (
          <ExhibitListItem key={index} exhibit={u} />
        ))}
      filters={[
        <SearchField
          key='SearchField'
          onSearch={onSearch}
          options={[]}
          value={searchQuery!}
        />,
        <Checkbox
          key='Switch'
          color='primary'
          label='Include Inactive'
          onChange={() => setShowInactive(!showInactive)}
          checked={showInactive}
          value={showInactive}
        />,
      ]}
      onScroll={() => console.log('You scrolled')}
      title='Exhibits'
    />
  );
};

export default ExhibitList;
